<script setup lang="ts">
const error = useError()

const statusCode = computed(() => error.value?.statusCode || 'Error')
const displayMessage = computed(() => {
  if (error.value?.statusCode === 500) {
    return "Oops! A little mess in the kitchen. We’ll be back shortly!"
  }
  return error.value?.message || "That page isn’t on the Kichieats menu."
})
</script>

<template>
  <NuxtLayout name="dashboard">
    <Block class="flex flex-col items-center justify-center min-h-[70vh] bg-transparent px-4 text-center">
      <h1 class="text-[120px] font-extrabold text-[#F7931E] leading-none tracking-wider">
        {{ statusCode }}
      </h1>

      <p class="mt-2 text-3xl font-semibold text-black">
        {{ displayMessage }}
      </p>

      <NuxtLink
        to="/"
        class="mt-10 inline-block rounded-md bg-[#F7931E] px-8 py-4 text-xl font-semibold text-white shadow-md hover:bg-[#e98213] transition-all"
      >
        Go back home
      </NuxtLink>
    </Block>
  </NuxtLayout>
</template>
